import { EPGConfig } from '../../../types';

type Props = {
    config: EPGConfig;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const StickyCellBorderMasking = ({ config }: Props) => {
    return null;
};
